import { useCallback } from "react";

const useFormatDate = () => {
  const formatEndDate = useCallback((date) => {
    if (!date) return "";

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const [year, month, day] = date.split("-");
    const monthIndex = parseInt(month, 10) - 1; // Get the correct month index (0-based)

    // Format date as "dd MMM yyyy"
    return `${day} ${monthNames[monthIndex]} ${year}`;
  }, []);

  return formatEndDate;
};

export default useFormatDate;
